<template>   
        
    <b-row class="slide-body">
        <b-col cols="2">
            <router-link :to="{name:'slide5',params:{lang:lang}}"><b-img left src="@/images/button-left.png" :title="$t('general.previous')" fluid></b-img></router-link>
        </b-col>

        <b-col cols="8">
        <b-row align-h="center" class="mt-5 pt-3 mb-5 pb-3">   
                <h1 style="color:#ffffff"><strong>{{ $t('slide6.text1') }}</strong></h1>
            </b-row>
            <b-row align-h="center" class="mt-5 pt-5 pb-3">   
                <h1 style="color:#ffff00"><strong>{{ $t('slide6.text2') }}</strong></h1>
            </b-row>
            <b-row align-h="center">   
                <h1 style="color:#ffff00"><strong>{{ $t('slide6.text3') }}</strong></h1>
            </b-row>           
        </b-col>

        <b-col cols="2">
            <router-link :to="{name:'slide7',params:{lang:lang}}"><b-img  right src="@/images/button-right.png" :title="$t('general.next')" fluid></b-img></router-link>
        </b-col>
    </b-row>                    
   
</template>

<script>
import {mapState} from 'vuex';

export default {
    props:['lang'],    
    computed: mapState(['showMenu']),
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);
    },
    created(){
        this.$i18n.locale=this.lang;
    }    
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        position:relative; 
        width: 100%; 
    }

</style>